import React, { useEffect, useState } from 'react';
import { Col, Row, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_USER_SUBJECT, GET_SINGLE_COHORT_NAME } from '../../../../graphql';
import { CohortSubjectItem } from '../common';
import { STUDENT_HOME, studentCohortPath } from '../../../../routes';
import ViewSpinner from '../../../../components/viewSpinner/ViewSpinner';
import './styles.less';

const Subjects = () => {
  const { id: urlCohortId } = useParams();
  // The caller's own enrolments; it takes no argument.
  const { data: userPayload, loading } = useQuery(GET_USER_SUBJECT);
  const {
    data: cohortPayload, loading: cohortLoading,
  } = useQuery(GET_SINGLE_COHORT_NAME, { variables: { id: urlCohortId } });
  const [subjects, setSubjects] = useState([]);
  const [cohortName, setCohortName] = useState(null);

  useEffect(() => {
    if (!loading && userPayload) {
      const cohortSubject = userPayload.mySubjects.filter(({ cohortId }) => cohortId === urlCohortId);
      setSubjects(cohortSubject);
    }
  }, [userPayload, loading, urlCohortId]);

  useEffect(() => {
    if (!cohortLoading && cohortPayload) {
      const { cohort } = cohortPayload;
      setCohortName(cohort.name);
    }
  }, [cohortPayload, cohortLoading]);

  return (
    <div>
      {!loading && userPayload ? (
        <Row className="student-subject">
          <Col span={24}>
            <Link to={STUDENT_HOME}><Button shape="circle" icon={<ArrowLeftOutlined />} /></Link>
            {cohortName && <h3 className="ic-ft-dosis">{`${cohortName} - Subjects`}</h3>}
          </Col>
          {subjects.map(({ id, name }) => (
            <CohortSubjectItem
              title={name}
              key={id}
              extras="Click learn to start subject"
              btnText="Learn"
              link={`${studentCohortPath(urlCohortId)}/learn?sub=${id}`}
            />
          ))}
        </Row>
      ) : <ViewSpinner />}
    </div>
  );
};

export default Subjects;
